// extracted by mini-css-extract-plugin
export default {"popoverContent":"CopyToClipboard--popoverContent--QgVEp","tooltipLabel":"CopyToClipboard--tooltipLabel--SejcM","copyIcon":"CopyToClipboard--copyIcon--OU5ZK"};